import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { IModel, ServiceNowCopySource } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ServiceNowCopySource),
    disabled: __IS_FABRIC_DPE__,
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class ServiceNowCopySourceAdapter extends CopySourceAdapter<ServiceNowCopySource, Model.ServiceNowSource> {
    protected model(): IModel {
        return ServiceNowCopySource.MODEL;
    }

    protected override async _toResource(copySource: ServiceNowCopySource): Promise<Model.ServiceNowSource> {
        return this._toTabularResource(copySource, this.model().name);
    }

    protected override async _toModel(
        resource: Model.ServiceNowSource,
        copyActivity: CopyActivity
    ): Promise<ServiceNowCopySource> {
        return this._toTabularModel(resource, copyActivity, this.model());
    }
}
